<div class="specs">
  <form [formGroup]="areaPropertiesForm" fxLayout="row">

    <!-- Area location -->
    <div class="location" fxFlex="40">
      <div fxFlex>
        <div class="title">
          {{ 'cluster' | translate }}:
          <mat-icon class="a"
            [inline]="true"
            [matTooltip]="'viewCluster' | translate"
            matTooltipPosition="above"
            (click)="goToLegacyBuilding()">input</mat-icon>
        </div>
        <mat-form-field>
          <mat-select formControlName="cluster">
            <mat-option *ngFor="let cluster of clusters" [value]="cluster._id">
              {{ cluster.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="authService.canRead('basicarea')" fxFlex>
        <div class="title">
          {{ 'areatemplate' | translate }}:
          <mat-icon class="a"
            [inline]="true"
            [matTooltip]="'viewareatemplate' | translate"
            matTooltipPosition="above"
            (click)="goToBasicArea()">input</mat-icon>
        </div>
        <mat-form-field>
          <mat-select formControlName="basicArea">
            <mat-option *ngFor="let basicArea of basicAreas" [value]="basicArea._id">
              {{ basicArea.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Area properties -->
    <div class="properties" fxFlex="60" fxLayout="row">
      <div fxFlex>
        <div class="title">{{ 'quantity' | translate }}:</div>
        <mat-form-field>
          <input 
            [readonly]="!authService.canUpdate('element')"
            matInput 
            formControlName="quantity" 
            type="number" 
            (keydown.enter)="submitAreaProperty($event)">
        </mat-form-field>
      </div>
      <div fxFlex>
        <div class="title">{{ 'surface' | translate }}:</div>
        <mat-form-field>
          <input
            [readonly]="!authService.canUpdate('element')"
            matInput 
            formControlName="surface"
            type="number" 
            (keydown.enter)="submitAreaProperty($event)">
          <span matSuffix>m<sup>2</sup></span>
        </mat-form-field>
      </div>
      <div fxFlex>
        <div class="title">{{ 'minimalheight' | translate }}:</div>
        <mat-form-field>
          <input 
            [readonly]="!authService.canUpdate('element')"
            matInput
            formControlName="height"
            type="number"
            float="1" 
            step="0.1"
            (keydown.enter)="submitAreaProperty($event)">
        </mat-form-field>
      </div>
      <div fxFlex>
        <div class="title">{{ 'expectedoccupation' | translate }}:</div>
        <mat-form-field>
          <input 
            [readonly]="!authService.canUpdate('element')"
            matInput
            formControlName="occupation"
            type="number"
            (keydown.enter)="submitAreaProperty($event)">
        </mat-form-field>
      </div>
    </div>

  </form>
</div>
